import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import style from './style.module.less';
import messages from './messages';

const IssuesLink = ({ errors, warnings, onOpenLabelBatchStatus }) => {
  const totalIssues = errors + warnings;
  return (
    <Button className={style.descendent} onClick={onOpenLabelBatchStatus} theme='link'>
      {totalIssues} <FormattedMessage {...messages.errorsLinkText} values={{ errors: totalIssues }} />
    </Button>
  );
};

IssuesLink.propTypes = {
  errors: PropTypes.number.isRequired,
  warnings: PropTypes.number,
  onOpenLabelBatchStatus: PropTypes.func.isRequired,
};

export { IssuesLink };
